import { Route, Routes } from 'react-router-dom';

import { LocationContextProvider } from '../context/locationContext';
import { RouteStops } from '../route/stops/RouteStops';
import { RoutesListContent } from './RoutesListContent';

export const RoutesList = () => (
  <Routes>
    <Route
      path={`/:routeId/*`}
      element={
        <LocationContextProvider>
          <RouteStops />
        </LocationContextProvider>
      }
    />

    <Route path="*" element={<RoutesListContent />} />
  </Routes>
);
